import { APP_VERSION } from '../generated/appVersion';

export const CLIENT_VERSION_HEADER = 'X-Client-Version';

export const getClientVersion = () => String(APP_VERSION || '').trim();

export const isCheckAuthUrl = (url) => (
  String(url || '').split('?')[0].replace(/\/+$/, '').endsWith('/api/check-auth')
);

export const getClientVersionHeaders = () => {
  const clientVersion = getClientVersion();
  return clientVersion ? { [CLIENT_VERSION_HEADER]: clientVersion } : {};
};
